import CustomInputs from './Inputs';
import { FORM_CONTROLFIELD_TYPES } from '../../constants/constants';
import { useError } from '../../utils/context/ErrorContext';
import { GetImages } from '../../utils/GetImages';
import NewSelectAuto from '../tenants/NewSelectAuto';
import AddTraspButton from '../firstTimeUserExperience/commonCom/AddTraspButton';
import React, { useEffect, useState } from 'react';
import Checkbox from '../../newComponents/form-fields/checkbox';
import apiHelper from '../../utils/apiHelper';
import { LeaseAgreementService } from '@propertelligent/client-api';

export interface DynamicAddMoreFormProps {
  data: any;
  setData: any;
  id?: any;
  showNonRefundable?: boolean;
  onDeletePayment?: (payment: any) => void | Promise<void>;
}

const DynamicAddMoreForm: React.FC<DynamicAddMoreFormProps> = ({ data, setData, id = undefined, showNonRefundable = false, onDeletePayment }) => {
  const { errors, setErrors, errorMessages, setErrorMessages, clearErrors } = useError();
  const [paymentTypes, setPaymentTypes] = useState([])
  const dataArray = Array.isArray(data) ? data : data ? [data] : [];

  const handleDeletePayment = async (paymentOrId) => {
    if (Array.isArray(dataArray) && dataArray.length <= 1) return;
    const payment = typeof paymentOrId === 'object' && paymentOrId !== null ? paymentOrId : dataArray.find(p => p?.id === paymentOrId);
    const idToRemove = payment?.id ?? paymentOrId;
    if (onDeletePayment && payment) {
      await Promise.resolve(onDeletePayment(payment));
    } else {
      setData(dataArray.filter(p => p?.id !== idToRemove));
    }
  };

  const handleChange = (id, field, value, index) => {
    if (Array.isArray(dataArray)) {
      setData(dataArray?.map(payment =>
        payment?.id === id ? { ...payment, [field]: value } : payment
      ));
      const errorKey = `${field}-${index}`;
      setErrors((prevErrors) => ({ ...prevErrors, [errorKey]: false }));
      setErrorMessages((prev) => ({ ...prev, [errorKey]: "" }));
    }
  };
  const getPaymentTypes = () => {
    apiHelper(LeaseAgreementService.getApiLeaseAgreementPaymentTypes, { showNotification: false })
      .then((res) => {
        if (res?.data?.success) {
          setPaymentTypes(res?.data?.success)
        }
      }).catch((err) => { })
  }

  useEffect(() => {
    getPaymentTypes()
  }, [])
  const handleAddPayment = () => {
    setData([...data,
    {
      id: data.length + 1,
      paymentType: "",
      amount: "",
      dueDate: "",
      gracePeriods: "",
      description: "",
      isNonRefundable: false,
    },
    ]);
  };

  return (
    <>
      <div className='dynamicAddMoreForm '>
        {Array.isArray(dataArray) && dataArray?.length > 0 ? (
          dataArray?.map((payment, index) => (<>
            <div className='dynamicAddMoreFormInput' key={payment?.id}>
              <div key={payment?.id} className="dynamicAddMoreForminputHeader  basic-form-fivefield  ">
                <NewSelectAuto
                  disabled={undefined}
                  setDisabled={undefined}
                  selected={payment?.paymentType}
                  setSelected={(value) => handleChange(payment?.id, 'paymentType', value, index)}
                  setSelectedOption={undefined}
                  required={true}
                  selectedOption={undefined}
                  data={paymentTypes}
                  title={"Wait till the data fetches"}
                  type="Payment Type"
                  label={index === 0 ? "Payment Type" : ''}
                  setError={() => { }}
                  error={errors[`paymentType-${index}`]}
                  errorMessage={errorMessages[`paymentType-${index}`]}
                  fromContractor={false}
                  width={"100%"}
                />
                <CustomInputs
                  name={"amount"}
                  labelText={index === 0 ? "Amount" : ""}
                  type={FORM_CONTROLFIELD_TYPES.TEXT}
                  value={payment?.amount ? payment?.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""}
                  isFormControl={true}
                  currencySymbol="$"
                  required={true}
                  onChange={(e) => {
                    let value = e.target.value.replace(/,/g, "");
                    value = value.replace(/^0+/, "");

                    if (value === "" || /^(\d+(\.\d{0,2})?)?$/.test(value)) {
                      handleChange(payment?.id, "amount", value, index);
                    }
                  }}
                  onBlur={() => {
                    if (payment?.amount) {
                      const formattedAmount = parseFloat(payment.amount).toFixed(2);
                      handleChange(payment?.id, "amount", formattedAmount, index);
                    }
                  }}
                  placeholder="Enter Amount"
                  myClassName="containerTextField normal_text"
                  isError={errors[`amount-${index}`]}
                  errorMessages={errorMessages[`amount-${index}`]}
                  containerClassName="w-100"
                  isCurrency={true}
                />
                <CustomInputs
                  name={"startDate"}
                  labelText={index === 0 ? 'Due Date' : ''}
                  type={FORM_CONTROLFIELD_TYPES.DATE}
                  isFormControl={true}
                  required={true}
                  value={payment?.dueDate || null}
                  onChange={(e) => {
                    handleChange(payment?.id, 'dueDate', e.target.value, index)
                  }}
                  placeholder="Select a Date"
                  myClassName="containerTextField normal_text"
                  isError={errors[`dueDate-${index}`]}
                  errorMessages={errorMessages[`dueDate-${index}`]}
                  containerClassName="w-100"
                />
                <CustomInputs
                  name={"graceperiods"}
                  labelText={index === 0 ? 'Grace Period' : ''}
                  type={FORM_CONTROLFIELD_TYPES.NUMBER}
                  value={payment?.gracePeriods}
                  isFormControl={true}
                  required={true}
                  currencySymbol="Days"
                  onChange={(e) => {
                    let value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      const numericValue = parseInt(value, 10) || 0;
                      if (numericValue <= 99) {
                        handleChange(payment?.id, "gracePeriods", value, index);
                      }
                    }
                  }}
                  placeholder="0"
                  myClassName="containerTextField normal_text"
                  isError={errors[`gracePeriods-${index}`]}
                  errorMessages={errorMessages[`gracePeriods-${index}`]}
                  containerClassName="w-100"
                />
                <CustomInputs
                  name={"description"}
                  labelText={index === 0 ? 'Description' : ''}
                  type={FORM_CONTROLFIELD_TYPES.TEXT}
                  value={payment?.description}
                  required={true}
                  isFormControl={true}
                  onChange={(e) => handleChange(payment?.id, 'description', e.target.value, index)}
                  placeholder="Enter Description"
                  myClassName="containerTextField normal_text"
                  isError={errors[`description-${index}`]}
                  errorMessages={errorMessages[`description-${index}`]}
                  containerClassName="w-100"
                  maxLength={250}
                />
              </div>
              {dataArray?.length > 1 && (
                <div className='delete-payment-icon' style={index === 0 ? { marginTop: "20px" } : {}}>
                  <img src={GetImages.DeleteRedBg} className='Icon32 cursore-pointer' alt='' onClick={() => handleDeletePayment(payment.id)} />
                </div>
              )}
            </div>
            {!showNonRefundable &&
              <div className="my-2">
                <Checkbox
                  isChecked={payment?.isNonRefundable}
                  onChange={() =>
                    handleChange(
                      payment?.id,
                      "isNonRefundable",
                      !payment?.isNonRefundable,
                      index
                    )
                  }
                  label="Is Non-Refundable"
                />
              </div>
            }
          </>
          ))
        ) : (
          <p>No data available</p>
        )}
        {!id ? (
          <div className=''>
            <AddTraspButton
              type="button"
              bname={"Add More"}
              onClick={handleAddPayment}
              border={true}
              width="fit-content"
              disabled={dataArray?.length === 4}
              className={`addtrasparent ${dataArray?.length === 4 ? "disabled" : ""}`}
              textclass={dataArray?.length === 4 ? "normal_text fw-600" : "normal_text fw-600 blue clickable"}
            />
          </div>
        ) : ""
        }
      </div>

    </>
  );
};

export default DynamicAddMoreForm;


